function parseLocalDate(value) {
  if (!value) return null;
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;
  const parsed = new Date(year, month - 1, day);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function startOfLocalDay(value = new Date()) {
  const date = value instanceof Date ? new Date(value) : new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function getCropLifecycle(crop = {}, referenceDate = new Date()) {
  const today = startOfLocalDay(referenceDate);
  const planting = parseLocalDate(crop.data_plantio ?? crop.dataPlantio);
  const harvest = parseLocalDate(crop.data_colheita ?? crop.dataColheita);
  const hasCrop = Boolean(String(crop.cultura || '').trim());

  if (harvest && harvest <= today) return 'harvested';
  if (planting && planting > today) return 'planned';
  if (hasCrop && planting) return 'active';
  return 'available';
}

export const isActiveCrop = (crop, referenceDate) => getCropLifecycle(crop, referenceDate) === 'active';
export const isPlannedCrop = (crop, referenceDate) => getCropLifecycle(crop, referenceDate) === 'planned';

export function summarizeCropLifecycles(crops = [], referenceDate = new Date()) {
  return crops.reduce((summary, crop) => {
    const lifecycle = getCropLifecycle(crop?.ciclo_atual || crop, referenceDate);
    summary[lifecycle] += 1;
    return summary;
  }, { active: 0, planned: 0, harvested: 0, available: 0 });
}
